import {formatNumber} from '@angular/common'
import {Component, effect, input, output} from '@angular/core'
import {KalpBuilding} from '../../../model/kalp-building'
import {Scenarios} from '../../../services/kalp.service'

@Component({
  selector: 'spb-summary-purpose',
  templateUrl: './summary-purpose.component.html',
  styleUrls: ['./summary-purpose.component.scss'],
  imports: []
})
export class SummaryPurposeComponent {
  public readonly building = input<KalpBuilding>(new KalpBuilding())

  public readonly scenario = input<Scenarios>(Scenarios.Purchase)

  public readonly scenarioDescription = input('')

  public readonly purposeResult = output<any>()

  /**
   * Until we make a type out of this... this works
   * as typings for the template.
   */
  public purpose = {
    title: '',
    items: [
      {text: 'Bostaden', value: ''},
      {text: 'Amorterings- och låneutrymmesgrundande värde', value: ''},
      {text: 'Datum för amorterings- och låneutrymmesgrundande värde', value: ''},
      {text: 'Bostad kan omvärderas tidigast', value: ''}
    ],
    loans: [
      {text: 'Lånebelopp', value: ''}
    ]
  }

  constructor() {
    effect(() => {
      this.purpose = {
        title: '',
        items: [
          {text: 'Bostad', value: ''},
          {text: 'Amorterings- och låneutrymmesgrundande värde', value: ''},
          {text: 'Datum för amorterings- och låneutrymmesgrundande värde', value: ''},
          {text: 'Bostad kan omvärderas tidigast', value: ''}
        ],
        loans: [
          {text: 'Lånebelopp', value: ''}
        ]
      }
      this.purpose.title = this.scenarioDescription()
      this.purpose.items[0].value = this.building().typeOfObject
      this.purpose.items[1].value = formatNumber(this.building().mortgageRequirementValue, 'sv', '1.0-0') + ' kr'
      const date = this.building().mortgageRequirementDate
      this.purpose.items[2].value = date ? new Date(date).toLocaleDateString('sv-SE') : ''

      if (date) {
        const fiveYearsLater = new Date(date)
        fiveYearsLater.setFullYear(fiveYearsLater.getFullYear() + 5)
        this.purpose.items[3].value = fiveYearsLater.toLocaleDateString('sv-SE')
      } else {
        this.purpose.items[3].value = ''
      }

      this.purpose.loans[0].value = formatNumber(this.building().activeLoanSum, 'sv', '1.0-0') + ' kr'

      if (this.scenario() === Scenarios.Purchase) {
        this.purpose.loans[0].text = 'Sökt lånebelopp'
      }

      if (this.scenario() === Scenarios.Increase) {
        this.purpose.loans[0].text = 'Befintliga lån'
        this.purpose.loans[0].value = formatNumber(this.building().allCurrentLoansOnBuilding, 'sv', '1.0-0') + ' kr'
        this.purpose.loans.push({
          text: 'Sökt lånebelopp',
          value: formatNumber(
            this.building().activeLoanSum + this.building().currentLoanSum - this.building().allCurrentLoansOnBuilding,
            'sv', '1.0-0') + ' kr'
        })
      }

      if (this.scenario() === Scenarios.Transfer) {
        this.purpose.loans[0].text = 'Befintliga lån'
        this.purpose.loans[0].value = formatNumber(this.building().currentLoanSum, 'sv', '1.0-0') + ' kr'
        this.purpose.loans.push({
          text: 'Befintliga lån som flyttas',
          value: formatNumber(this.building().activeLoanSum, 'sv', '1.0-0') + ' kr'
        })
      }

      // When conditions all loans, both those that change and those that do not
      // Should be included here.
      if (this.scenario() === Scenarios.Conditions) {
        this.purpose.loans[0].value = formatNumber(this.building().activeLoanSum + this.building().currentLoanSum, 'sv', '1.0-0') + ' kr'
      }
      this.purposeResult.emit(this.purpose)
    })
  }
}
